var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3999 10.5639L20.9822 9.19515L16.7723 0.660254C16.6573 0.426573 16.4681 0.237403 16.2344 0.122418C15.6484 -0.166901 14.9362 0.074198 14.6432 0.660254L10.4332 9.19515L1.01552 10.5639C0.75588 10.6009 0.51849 10.7233 0.336739 10.9088C0.117011 11.1347 -0.00406867 11.4385 0.000104399 11.7536C0.00427746 12.0686 0.133362 12.3691 0.358994 12.5891L7.17282 19.2323L5.56302 28.6129C5.52527 28.8311 5.54942 29.0555 5.63272 29.2607C5.71603 29.4659 5.85516 29.6436 6.03434 29.7738C6.21353 29.9039 6.42559 29.9812 6.64648 29.997C6.86737 30.0127 7.08826 29.9663 7.28409 29.8629L15.7077 25.4341L24.1313 29.8629C24.3613 29.9853 24.6284 30.0261 24.8843 29.9816C25.5297 29.8703 25.9637 29.2583 25.8524 28.6129L24.2426 19.2323L31.0564 12.5891C31.2419 12.4073 31.3643 12.1699 31.4014 11.9103C31.5015 11.2612 31.049 10.6603 30.3999 10.5639Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.2dda460a1009c4ea5b6c8f5ada156123.svg";
export { ForwardRef as ReactComponent };